// extracted by mini-css-extract-plugin
export default {"content":"AdminLayout_content__IZiGU"};